"use client";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFire,
    faBan,
    faClock,
    faLock,
    faEnvelopeOpen,
} from "@fortawesome/free-solid-svg-icons";
import globalVariables from "../../GlobalVariable";
import Turnstile, { useTurnstile } from "react-turnstile";

import "App.css";

import SubmissionModal from "../../components/SubmissionModal";

const FormWidgetChat = ({
    idTrackGoogleAds,
    id2,
    chat,
    set_request_contact_is_send,
}) => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        service: "",
    });

    const [errors, setErrors] = useState({});
    const [captchaIsPassed, setCaptchaIspassed] = useState(false);
    const [vefifyCaptcha, setVerifyCaptcha] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // --- NUEVO ESTADO PARA EL MODAL ---
    const [modalState, setModalState] = useState(null); // null, 'submitting', 'success', 'error'
    const [businessData, setBusinessData] = useState(null);

    // --- NUEVOS ESTADOS PARA SERVICIOS DINÁMICOS ---
    const [services, setServices] = useState([]);
    const [businessYelpId, setBusinessYelpId] = useState(null);

    useEffect(() => {
        const fetchBusinessData = async () => {
            if (!businessYelpId) return;
            try {
                const response = await axios.get(`${globalVariables.domain}/business/${businessYelpId}`);
                if (response.data && response.data.content) {
                    setBusinessData(response.data.content);
                }
            } catch (error) {
                console.error("Error fetching business data:", error);
            }
        };
        fetchBusinessData();
    }, [businessYelpId]);
    const [businessId, setBusinessId] = useState(null); // _id del business
    const [isLoadingServices, setIsLoadingServices] = useState(false);
    const [otherService, setOtherService] = useState(""); // NUEVO ESTADO

    const turnstile = useTurnstile();

    // --- FUNCIÓN PARA OBTENER BUSINESS YELP ID ---
    const getBusinessYelpId = () => {
        // 1. Intentar obtener desde la URL
        const urlParams = new URLSearchParams(window.location.search);
        const yelpIdFromUrl = urlParams.get('business_yelp_id');
        if (yelpIdFromUrl) {
            console.log('Business Yelp ID desde URL:', yelpIdFromUrl);
            return yelpIdFromUrl;
        }

        // 2. Intentar obtener desde el hash de la URL
        const hash = window.location.hash;
        if (hash && hash.includes('business_yelp_id=')) {
            const hashParams = new URLSearchParams(hash.substring(1));
            const yelpIdFromHash = hashParams.get('business_yelp_id');
            if (yelpIdFromHash) {
                console.log('Business Yelp ID desde hash:', yelpIdFromHash);
                return yelpIdFromHash;
            }
        }

        // 3. Intentar obtener desde localStorage (si fue guardado previamente)
        try {
            const storedYelpId = localStorage.getItem('business_yelp_id');
            if (storedYelpId) {
                console.log('Business Yelp ID desde localStorage:', storedYelpId);
                return storedYelpId;
            }
        } catch (e) {
            console.log('No se pudo acceder a localStorage:', e);
        }

        // 4. Intentar obtener desde postMessage (si viene del widget)
        // Esta función se ejecutará cuando se reciba el mensaje
        return null;
    };

    // --- FUNCIÓN PARA OBTENER SERVICIOS DEL ENDPOINT ---
    const fetchServices = async (yelpId) => {
        if (!yelpId) return;

        setIsLoadingServices(true);
        try {
            console.log('Obteniendo servicios para business_yelp_id:', yelpId);

            // Agregar timestamp para evitar caché
            const timestamp = Date.now();
            const response = await axios.get(`${globalVariables.domain}/business/${yelpId}?_t=${timestamp}`, {
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                }
            });

            console.log('Respuesta completa del servidor:', response.data);
            console.log('Status de la respuesta:', response.status);

            // Obtener el _id del business
            let businessData = null;
            if (response.data && response.data.content) {
                businessData = response.data.content;
            } else if (response.data) {
                businessData = response.data;
            }

            if (businessData && businessData._id) {
                console.log('Business ID (_id) obtenido:', businessData._id);
                setBusinessId(businessData._id);
            }

            // Obtener servicios
            if (response.data && response.data.services && Array.isArray(response.data.services)) {
                console.log('Servicios obtenidos del servidor:', response.data.services);
                setServices(response.data.services);
            } else if (businessData && businessData.services && Array.isArray(businessData.services)) {
                console.log('Servicios obtenidos del content:', businessData.services);
                setServices(businessData.services);
            } else {
                console.log('No se encontraron servicios en la respuesta. Datos recibidos:', response.data);
                // Sin servicios - el formulario no funcionará hasta obtener servicios de la API
                setServices([]);
            }
        } catch (error) {
            console.error('Error obteniendo servicios:', error);
            console.error('Status del error:', error.response?.status);
            console.error('Datos del error:', error.response?.data);

            // Sin servicios - el formulario no funcionará hasta obtener servicios de la API
            setServices([]);
            setBusinessId(null); // Limpiar businessId en caso de error
        } finally {
            setIsLoadingServices(false);
        }
    };

    // --- FUNCIÓN PARA FORMATEAR TELÉFONO ---
    // --- FUNCIÓN PARA FORMATEAR TELÉFONO (USA +1) ---
    const formatPhoneNumber = (value) => {
        // Remover todo no-dígito
        let digits = value.replace(/\D/g, "");

        // Si no hay dígitos, devolver vacío
        if (!digits) return "";

        // Asegurar que empiece con 1 (USA code)
        // Casos:
        // 1. Usuario escribe "4..." -> digits="4..." -> prepend 1 -> "14..."
        // 2. Usuario escribe "1..." -> digits="1..." -> ok
        if (digits[0] !== "1") {
            digits = "1" + digits;
        }

        // Limitar a 11 dígitos (1 + area(3) + phone(7))
        digits = digits.slice(0, 11);

        // Formatear
        // digits[0] es siempre '1'
        // Formatos progresivos:
        // "1" -> "+1"
        // "14" -> "+1 (4"
        // "140" -> "+1 (40"
        // "1408" -> "+1 (408"
        // "14081" -> "+1 (408) 1"
        // "1408123" -> "+1 (408) 123"
        // "14081234" -> "+1 (408) 123-4"

        const country = digits.slice(0, 1); // "1"
        const area = digits.slice(1, 4);
        const prefix = digits.slice(4, 7);
        const line = digits.slice(7, 11);

        let formatted = `+${country}`;

        if (area) {
            formatted += ` (${area}`;
        }
        if (area.length === 3) {
            formatted += `)`;
        }
        if (prefix) {
            formatted += ` ${prefix}`;
        }
        if (prefix.length === 3 && line) { // añadimos guión solo si hay algo después
            formatted += `-${line}`;
        }

        return formatted;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Formatear teléfono si es el campo phone
        if (name === "phone") {
            const formatted = formatPhoneNumber(value);
            setFormData((prev) => ({
                ...prev,
                [name]: formatted,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        // Limpiar otherService si cambian a otra opción
        if (name === "service" && value !== "Other") setOtherService("");
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "This field is required";

        // Validar teléfono: debe tener exactamente 11 dígitos (1 del country code + 10 del número)
        const phoneDigits = formData.phone.replace(/\D/g, '');
        if (!formData.phone.trim()) {
            newErrors.phone = "This field is required";
        } else if (phoneDigits.length !== 11) {
            newErrors.phone = "Phone number must be a valid USA number (+1 XXX-XXX-XXXX)";
        }

        if (!formData.service.trim() || formData.service === "Select Service")
            newErrors.service = "This field is required";
        // Validar Other
        if (formData.service === "Other" && !otherService.trim())
            newErrors.otherService = "Please specify the service";
        if (services.length === 0 && !isLoadingServices) {
            newErrors.service = "Services are not available. Please try again later.";
        }
        return newErrors;
    };

    // --- Funciones de notificación comentadas ---
    /*
    const sendEmail = async (email_message, subject) => { ... };
    const sendSms = async (to, body) => { ... };
    */

    function obtenerTimestampActual() {
        return Date.now();
    }

    const gtag_report_conversion = (url) => {
        const callback = () => {
            if (typeof url !== "undefined") {
                window.location = url;
            }
        };
        if (window.gtag) {
            window.gtag("event", "conversion", {
                send_to: `${idTrackGoogleAds}/${id2}`,
                event_callback: callback,
            });
        }
        return false;
    };

    // --- USEEFFECT PARA INICIALIZAR BUSINESS YELP ID Y SERVICIOS ---
    useEffect(() => {
        // Obtener businessYelpId al cargar el componente
        const yelpId = getBusinessYelpId();
        if (yelpId) {
            setBusinessYelpId(yelpId);
            fetchServices(yelpId);
        }

        // Listener para postMessage del widget
        const handleMessage = (event) => {
            console.log('Mensaje recibido via postMessage:', event.data);

            if (event.data.type === 'BUSINESS_YELP_ID') {
                const receivedYelpId = event.data.businessYelpId;
                console.log('Business Yelp ID recibido via postMessage:', receivedYelpId);
                setBusinessYelpId(receivedYelpId);

                // Guardar en localStorage para futuras cargas
                try {
                    localStorage.setItem('business_yelp_id', receivedYelpId);
                } catch (e) {
                    console.log('No se pudo guardar en localStorage:', e);
                }

                fetchServices(receivedYelpId);
            } else if (event.data && typeof event.data === 'string') {
                // Intentar parsear si es un string JSON
                try {
                    const parsedData = JSON.parse(event.data);
                    if (parsedData.type === 'BUSINESS_YELP_ID' && parsedData.businessYelpId) {
                        console.log('Business Yelp ID recibido via postMessage (string):', parsedData.businessYelpId);
                        setBusinessYelpId(parsedData.businessYelpId);

                        try {
                            localStorage.setItem('business_yelp_id', parsedData.businessYelpId);
                        } catch (e) {
                            console.log('No se pudo guardar en localStorage:', e);
                        }

                        fetchServices(parsedData.businessYelpId);
                    }
                } catch (e) {
                    // No es JSON, ignorar
                }
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${idTrackGoogleAds}`;
        document.head.appendChild(script);

        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag("js", new Date());
            gtag("config", `${idTrackGoogleAds}`);
        };

        return () => {
            document.head.removeChild(script);
        };
    }, [idTrackGoogleAds]);

    const saveLead = async () => {
        try {
            // Obtener dígitos (ej: 14081234567) y asegurar el + al inicio
            const phoneDigitsRaw = formData.phone.replace(/\D/g, '');
            // El backend espera +14081234567
            const phoneDigits = `+${phoneDigitsRaw}`;

            const data = {
                conversationId: "N/A",
                locationId: "manual",
                lastMessageDate: obtenerTimestampActual(),
                fullName: formData.name,
                tags: [{
                    ...formData,
                    service: formData.service === "Other" ? otherService : formData.service
                }, "azucarai web form"],
                phone: phoneDigits, // Enviar solo dígitos sin formato
                email: formData.email,
                lead_source: "form",
                business_yelp_id: businessYelpId,
                business_id: businessId, // _id del business
                service_type: formData.service === "Other" ? otherService : formData.service, // Cambiado de selected_service a service_type
            };
            console.log('Enviando lead con datos:', data);
            await axios.post(`${globalVariables.domain}/lead_systematik/`, data);
            gtag_report_conversion();
        } catch (error) {
            console.error("Error saving lead:", error);
            throw error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        if (!captchaIsPassed) {
            setVerifyCaptcha(true);
            return;
        }

        setIsSubmitting(true);
        setModalState("submitting");
        setErrors({});

        try {
            await saveLead();
            setModalState("success");
        } catch (error) {
            console.error("Form submission error:", error);
            setModalState("error");
        }
        // El 'finally' ya no es necesario aquí para setIsSubmitting
    };

    // --- NUEVA FUNCIÓN PARA CERRAR EL MODAL Y REINICIAR ---
    const handleCloseModal = () => {
        setModalState(null);
        setIsSubmitting(false);
        // Reiniciar el formulario solo si el envío fue exitoso
        if (modalState === "success") {
            setFormData({ name: "", phone: "", service: "", email: "" });
            if (turnstile) turnstile.reset();
            setCaptchaIspassed(false);
            setVerifyCaptcha(false);
            if (set_request_contact_is_send) set_request_contact_is_send(true);
        }
    };

    const main_div_class = chat
        ? ""
        : "flex flex-col items-center justify-center bg-transparent";

    return (
        <>
            <SubmissionModal
                state={modalState}
                onClose={handleCloseModal}
                companyName={businessData?.business_name || "Company"}
                phoneNumber={businessData?.phone_web || businessData?.main_phone || businessData?.phone_google || businessData?.phone_yelp || "+1 (408) 509-0579"}
            />
            <div className={main_div_class}>
                <div className="w-full ">
                    <form onSubmit={handleSubmit} className="space-y-4 p-4" autoComplete="on">
                        {/* Inputs en grid si chat = true */}
                        <div className={chat ? "grid grid-cols-2 gap-3" : "space-y-4"}>
                            <div>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                    autoComplete="name"
                                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.name
                                        ? "border-red-500 focus:ring-red-500"
                                        : "border-gray-300 focus:ring-blue-500"
                                        }`}
                                />
                                {errors.name && (
                                    <p className="mt-1 text-sm text-red-500">{errors.name}</p>
                                )}
                            </div>
                            <div>
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                    autoComplete="tel"
                                    maxLength={17}
                                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.phone
                                        ? "border-red-500 focus:ring-red-500"
                                        : "border-gray-300 focus:ring-blue-500"
                                        }`}
                                />
                                {errors.phone && (
                                    <p className="mt-1 text-sm text-red-500">{errors.phone}</p>
                                )}
                            </div>
                        </div>

                        <div className={chat ? "grid grid-cols-2 gap-3" : "space-y-4"}>
                            <div>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                    autoComplete="email"
                                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.email
                                        ? "border-red-500 focus:ring-red-500"
                                        : "border-gray-300 focus:ring-blue-500"
                                        }`}
                                />
                                {errors.email && (
                                    <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                                )}
                            </div>
                            <div>
                                <select
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    disabled={isSubmitting || isLoadingServices || services.length === 0}
                                    className={`w-full px-4 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 ${errors.service
                                        ? "border-red-500 focus:ring-red-500"
                                        : "border-gray-300 focus:ring-blue-500"
                                        }`}
                                >
                                    <option value="" disabled>
                                        {isLoadingServices
                                            ? "Loading services..."
                                            : services.length === 0
                                                ? "No services available"
                                                : "Select Service"
                                        }
                                    </option>
                                    {services.map((service, index) => (
                                        <option key={index} value={service}>
                                            {service}
                                        </option>
                                    ))}
                                    <option value="Other">Other</option> {/* NUEVA OPCIÓN */}
                                </select>
                                {formData.service === "Other" && (
                                    <input
                                        type="text"
                                        name="otherService"
                                        placeholder="Please specify the service"
                                        value={otherService}
                                        onChange={e => setOtherService(e.target.value)}
                                        disabled={isSubmitting}
                                        className={`mt-2 w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.otherService
                                            ? "border-red-500 focus:ring-red-500"
                                            : "border-gray-300 focus:ring-blue-500"
                                            }`}
                                    />
                                )}
                                {errors.service && (
                                    <p className="mt-1 text-sm text-red-500">{errors.service}</p>
                                )}
                                {errors.otherService && (
                                    <p className="mt-1 text-sm text-red-500">{errors.otherService}</p>
                                )}
                                {isLoadingServices && (
                                    <p className="mt-1 text-sm text-gray-500">Loading services from business...</p>
                                )}
                                {!isLoadingServices && services.length === 0 && businessYelpId && (
                                    <div className="mt-1">
                                        <p className="text-sm text-red-500">
                                            No services found for this business. Please check the business ID or try again later.
                                        </p>
                                        <button
                                            type="button"
                                            onClick={() => fetchServices(businessYelpId)}
                                            className="mt-1 text-xs text-blue-600 hover:text-blue-800 underline"
                                        >
                                            Retry loading services
                                        </button>
                                    </div>
                                )}
                                {!isLoadingServices && services.length === 0 && !businessYelpId && (
                                    <p className="mt-1 text-sm text-orange-500">
                                        Business ID not found. Please ensure the widget is properly configured.
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* Debug Info - Temporal */}
                        {process.env.NODE_ENV === 'development' && (
                            <div className="p-3 bg-gray-100 rounded-lg text-sm">
                                <p><strong>Debug Info:</strong></p>
                                <p>Business Yelp ID: {businessYelpId || 'No encontrado'}</p>
                                <p>Business ID (_id): {businessId || 'No encontrado'}</p>
                                <p>Servicios cargados: {services.length}</p>
                                <p>Cargando servicios: {isLoadingServices ? 'Sí' : 'No'}</p>
                                <p>URL actual: {window.location.href}</p>
                                <p>URL params: {new URLSearchParams(window.location.search).toString() || 'Ninguno'}</p>
                                <div className="mt-2 space-x-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const testId = prompt('Ingresa un business_yelp_id para probar:');
                                            if (testId) {
                                                setBusinessYelpId(testId);
                                                fetchServices(testId);
                                            }
                                        }}
                                        className="px-3 py-1 bg-blue-500 text-white rounded text-xs"
                                    >
                                        Probar Business ID
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (businessYelpId) {
                                                fetchServices(businessYelpId);
                                            }
                                        }}
                                        className="px-3 py-1 bg-green-500 text-white rounded text-xs"
                                    >
                                        Recargar Servicios
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Captcha */}
                        <div>
                            <Turnstile
                                sitekey="0x4AAAAAAA11EXR57l9M1Gd2"
                                onVerify={() => setCaptchaIspassed(true)}
                                theme="light"
                            />
                        </div>

                        {!captchaIsPassed && vefifyCaptcha && (
                            <p className="mt-1 text-sm text-red-500">
                                This field is required
                            </p>
                        )}

                        {/* Botón */}
                        <div>
                            <button
                                type="submit"
                                disabled={isSubmitting || services.length === 0}
                                className={`w-full px-4 py-2 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors duration-300 ${isSubmitting || services.length === 0
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-[#CA0712] hover:bg-red-700"
                                    }`}
                            >
                                {isSubmitting
                                    ? "Submitting..."
                                    : services.length === 0
                                        ? "No Services Available"
                                        : "Request Service"
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default FormWidgetChat;
